import { render, staticRenderFns } from "./TelephonyBridge.vue?vue&type=template&id=3359f082&"
import script from "./TelephonyBridge.vue?vue&type=script&lang=js&"
export * from "./TelephonyBridge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports